// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"8957":"25dcaf7dbd15f13d","9115":"de322c883845cdd6"}[chunkId] + ".css";
};